import React from 'react';
import PropTypes from 'prop-types';

import { FrameCard } from '@weezevent/nacre';
import FormDivider from './formDivider';
import FormInput from './formInput';
import FormSelect from './formSelect';
import FormCheckbox from './formCheckbox';
import FormPhone from './formPhone';
import FormAreafield from './formAreafield';
import FormFile from './formFile';
import FormBirthdate from './formBirthdate';
import FormCountry from './formCountry';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n/i18n';
import FormTitle from './formTitle';
import Style from './formPreview.module.css';
import FormImage from './formImage';

//For FIELDS.date : it is a field which is not at all formatted in a homogeneous way in Menhir.
//For the moment we propose an inputText to ensure backwards compatibility.
//In the near future, we must create a custom date field on the Menhir side which, as output, returns an isoString
const FIELDS = {
    phone: FormPhone,
    textfield: FormInput,
    email: FormInput,
    textarea: FormAreafield,
    file: FormFile,
    image: FormImage,
    checkbox: FormCheckbox,
    select: FormSelect,
    divider: FormDivider,
    country: FormCountry,
    birthdate: FormBirthdate,
    title: FormTitle,
    date: FormInput
};

function GenericField({ field, ...rest }) {
    const label = field.form_field.get_translated_label(i18n.language.toLowerCase());

    if (field.form_field.subtype) {
        const Component = FIELDS[field.form_field.subtype];
        if (Component) {
            return <Component field={field} label={label} {...rest} />;
        }
    }

    if (!FIELDS[field.form_field.field_type]) {
        return <FormInput field={field} label={label} {...rest} />;
    }

    const ComponentType = FIELDS[field.form_field.field_type];
    return <ComponentType field={field} label={label} {...rest} />;
}

function Form({ fields, form, ...rest }) {
    if (!fields.length) {
        return null;
    }

    return (
        <>
            {fields
                .sort((a, b) => a.order - b.order)
                .map((field, index) => (
                    <GenericField
                        key={field['id'] || index}
                        field={field}
                        id={form ? field.form_field.weez_id : null}
                        value={form && form[field.form_field.weez_id] !== undefined ? form[field.form_field.weez_id] : null}
                        {...rest}
                    />
                ))}
        </>
    );
}

export function FormPreview({ fields, form = null, onChangeForm = () => {}, usage = 'attendee', locale = 'en-GB', withPadding = true }) {
    const { t } = useTranslation();

    return (
        <div>
            {!form ? (
                <div className={withPadding ? Style['form-preview__padding'] : ''}>
                    <FrameCard title={t('ticket.form.preview.formAttendee')} className={Style['card']}>
                        <Form fields={fields.filter(f => f.usage === 'attendee' && !f.deleted)} />
                    </FrameCard>
                    <FrameCard title={t('ticket.form.preview.formBuyer')} className={Style['card']}>
                        <Form fields={fields.filter(f => f.usage === 'buyer' && !f.deleted)} />
                    </FrameCard>
                </div>
            ) : (
                <Form fields={fields.filter(f => f.usage === usage)} form={form} onChangeForm={onChangeForm} locale={locale} />
            )}
        </div>
    );
}

FormPreview.propTypes = {
    fields: PropTypes.array,
    form: PropTypes.object,
    onChangeForm: PropTypes.func,
    usage: PropTypes.string,
    locale: PropTypes.string
};
